import React from 'react';
import ProductsHero from '../components/ProductsHero/ProductsHero';
import ProductTaskContent from '../components/ProductTaskContent/ProductTaskContent';
import './Products.css';

const ProductsTask = () => {
  return (
    <div className="products-page">
      <ProductsHero title="Tasks" bannerSection="Products > Task">
        <p className='text-muted'>
          flowdo Tasks allows you to manage your personal or corporate Tasks (also called as To Do List) in
          collaboration with your team. Create unlimited one time or repeated task with the ability to set
          reminders and create transactional statements.
        </p>
      </ProductsHero>
      <ProductTaskContent />
    </div>
  );
};

export default ProductsTask;
